import { Clock, Calendar, User, MapPin, Users, Building } from "lucide-react";
import { useSelector } from "react-redux";

const VirtualCourseCard = ({ courses, onClick, courseType }) => {
  const { id } = useSelector((state) => state.auth);

  return (
    <div className="p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {courses.map((course) => {
          const isFull = course.seatsAvailable === 0;
          const isUserRegistered =
            course.registeredUsers?.includes(id) || false;

          return (
            <div
              key={course.id}
              className="bg-white rounded-xl shadow-md overflow-hidden border border-blue-300 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="bg-indigo-600 h-3 w-full"></div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  {course.name}
                </h3>

                <p className="text-gray-600 mb-5 line-clamp-3 text-sm leading-relaxed">
                  {course.description}
                </p>

                <div className="space-y-3 mb-6">
                  {courseType === "partnerinstitution" && (
                    <div className="flex items-center text-gray-700">
                      <Building size={18} className="mr-2 text-indigo-500" />
                      <span className="font-medium">Institution:</span>
                      <span className="ml-2">{course.institutionName}</span>
                    </div>
                  )}
                  <div className="flex items-center text-gray-700">
                    <User size={18} className="mr-2 text-indigo-500" />
                    <span className="font-medium">Instructor:</span>
                    <span className="ml-2">{course.instructor}</span>
                  </div>

                  <div className="flex items-center text-gray-700">
                    <Calendar size={18} className="mr-2 text-indigo-500" />
                    <span className="font-medium">Date:</span>
                    <span className="ml-2">{course.date}</span>
                  </div>

                  <div className="flex items-center text-gray-700">
                    <Clock size={18} className="mr-2 text-indigo-500" />
                    <span className="font-medium">Time:</span>
                    <span className="ml-2">{course.time}</span>
                  </div>

                  <div className="flex items-center text-gray-700">
                    <Clock size={18} className="mr-2 text-indigo-500" />
                    <span className="font-medium">Duration:</span>
                    <span className="ml-2">{course.duration} Minutes</span>
                  </div>

                  <div className="flex items-center text-gray-700">
                    <MapPin size={18} className="mr-2 text-indigo-500" />
                    <span className="font-medium">Timezone:</span>
                    <span className="ml-2">{course.timezone}</span>
                  </div>

                  <div className="flex items-center text-gray-700">
                    <Users size={18} className="mr-2 text-indigo-500" />
                    <span className="font-medium">Seats Available:</span>
                    <span
                      className={`ml-2 ${
                        isFull ? "text-red-500 font-bold" : ""
                      }`}
                    >
                      {isFull ? "No seats available" : course.seatsAvailable}
                    </span>
                  </div>
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="text-2xl font-bold text-indigo-600">
                    ${course.price}
                  </div>

                  {isFull ? (
                    <button
                      disabled
                      className="px-4 py-2 bg-gray-400 text-white font-medium rounded-lg cursor-not-allowed"
                    >
                      Fully Booked
                    </button>
                  ) : isUserRegistered ? (
                    <button
                      disabled
                      className="px-4 py-2 bg-blue-300 text-white font-medium rounded-lg cursor-not-allowed"
                    >
                      Already Registered
                    </button>
                  ) : (
                    <button
                      onClick={() => onClick(course)}
                      className="px-4 py-2 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 transition-colors"
                    >
                      Register Now
                    </button>
                  )}
                </div>

                {isFull && (
                  <div className="mt-3 text-sm text-red-500">
                    This course is currently full. Please check back later or
                    explore other courses.
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VirtualCourseCard;
